<template>
  <div id="screen">
    <current-time></current-time>
    <div class="stations">
      <station
        :stationName="'Frösunda port'"
        :color="'#6b2f89'"
        :journeys="stations && stations[3458]"
        :buses="true"
        :exclude="['67']">
      </station>
      <station
        :stationName="'Frösunda'"
        :color="'#d6101c'"
        :journeys="stations && stations[3415]"
        :buses="true"
        :limit="14"
        :exclude="['67']">
      </station>
      <station
        :stationName="'Bergshamra'"
        :journeys="stations && stations[9202]"
        :metros="true">
      </station>
      <station
        :stationName="'Solna station'"
        :color="'#5ba4bb'"
        :journeys="stations && stations[9509]"
        :trains="true">
      </station>
      <station
        :stationName="'Solna station'"
        :color="'#5ba4bb'"
        :journeys="stations && stations[9509]"
        :trams="true">
      </station>
      <station
        :stationName="'Frösundavik'"
        :color="'#85c830'"
        :class="['wide-last-column']"
        :journeys="{
          LatestUpdate: '2018-10-18T12:05:58',
          Buses: [{ Destination: 'Frösundavik<span class=\'timetable-arrows\'></span>Solna stn', DisplayTime: '07-09:30', StopPointNumber: '123', JourneyNumber: '1' },
                  { Destination: 'Frösundavik<span class=\'timetable-arrows\'></span>Solna stn', DisplayTime: '15-18', StopPointNumber: '123', JourneyNumber: '2' }
          ]
        }"
        :showLastUpdated="false"
        :buses="true"
        :departureHeading="'Vardagar'"
        :footerText="'Gratis skyttelbuss non-stop mellan Solna Station och Frösundavik'">
      </station>
      <!-- <station
        :stationName="'Frösunda'"
        :distance="{ type: 'walk', displayTime: '2 min' }"
        :color="'#d6101c'"
        :class="['wide-last-column']"
        :journeys="{
          LatestUpdate: '2018-10-18T12:05:58',
          Buses: [{ Destination: 'Cityterminalen', DisplayTime: '15:10', LineNumber: '565X', StopPointNumber: '123', JourneyNumber: '1' },
                  { Destination: 'Cityterminalen', DisplayTime: '15:40', LineNumber: '565X', StopPointNumber: '123', JourneyNumber: '2' },
                  { Destination: 'Cityterminalen', DisplayTime: '16:10', LineNumber: '565X', StopPointNumber: '123', JourneyNumber: '3' },
                  { Destination: 'Cityterminalen', DisplayTime: '16:40', LineNumber: '565X', StopPointNumber: '123', JourneyNumber: '4' },
                  { Destination: 'Cityterminalen', DisplayTime: '17:10', LineNumber: '565X', StopPointNumber: '123', JourneyNumber: '5' },
                  { Destination: 'Cityterminalen', DisplayTime: '17:40', LineNumber: '565X', StopPointNumber: '123', JourneyNumber: '6' }
          ]
        }"
        :showLastUpdated="false"
        :buses="true"
        :departureHeading="'Mån-Fre'"
        :footerText="'Direktbuss 565x går utan stopp från Cityterminalen direkt till Frösundavik på morgonen och från Frösundavik direkt till Cityterminalen på eftermiddagen.'">
      </station>-->
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import CurrentTime from './components/Shared/CurrentTime.vue'
import Station from './components/Timetable/Station.vue'
import axios from 'axios'

export default {
  data () {
    return {
      interval: null,
      stations: {},
      cachedData: []
    }
  },
  created () {
    this.loadData()
    this.interval = setInterval(() => {
      this.loadData()
    }, 30000)
  },
  beforeDestroy () {
    clearInterval(this.interval)
    this.interval = null
  },
  methods: {
    loadData () {
      axios.get(`https://gate01.se/api/timetable/read.php`)
        .then(response => {
          if (response && response.data) {
            console.log('response.data', response.data)
            this.cachedData = response.data
            response.data.forEach(station => {
              let data = JSON.parse(station.response_data)
              Vue.set(this.stations, station.site_id, data)
            })
          }
        }).catch(() => {
          // offline
          this.cachedData.forEach(station => {
            let data = JSON.parse(station.response_data)
            Vue.set(this.stations, station.site_id, data)
          })
        })
    }
  },
  components: {
    CurrentTime,
    Station
  }
}
</script>

<style lang="scss">
  @import 'style/app.scss';
  #screen {
    color: white;
    padding: 8rem 8rem 0 8rem;
    .stations {
      column-count: 2;
      column-gap: 8rem;
      > * {
        margin-bottom: 2rem;
      }
    }
  }
</style>
